import React from 'react';
import PropTypes from 'prop-types';
import styles from './BenefitsSections.pcss';
import BenefitItem from './BenefitItem';

const BenefitsSections = props => {
    const benefits = props.sectionData.benefits || [];

    return (
        <div className={styles.section}>
            <div className={styles.benefits}>
                {benefits.map((item, key) => (
                    <BenefitItem
                        key={key}
                        title={item.title}
                        description={item.body}
                        image={item.backgroundImage}
                    />
                ))}
            </div>
        </div>
    );
};

BenefitsSections.propTypes = {
    sectionData: PropTypes.object
};

BenefitsSections.defaultProps = {
    sectionData: {}
};

export default BenefitsSections;
